import { toNDigits } from '@mail/cross-sizes-utils';
import classNames from 'clsx';
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { getErrorInfo, getFileName } from 'reactApp/modules/uploadList/uploadList.getters';
import { EFileError, IInputFile } from 'reactApp/modules/uploadList/uploadList.model';
import { getUserFileSizeLimit } from 'reactApp/modules/uploadList/uploadList.selectors';
import FilePicture from 'reactApp/ui/FilePicture/FilePicture';

import styles from './Problems.css';

interface IProps {
    file: IInputFile;
}

export const InfoErrorComponent = memo(({ file }: IProps) => {
    const userFileSizeLimit = toNDigits({
        bytes: useSelector(getUserFileSizeLimit),
        maxDigitsCount: 3,
    }).value;
    const error = file.error || EFileError.UNKNOWN;
    const errorInfo = getErrorInfo(error, { userFileSizeLimit, fileName: getFileName(file) });

    return (
        <div className={styles.problem}>
            <div className={styles.icon}>
                <FilePicture
                    icon={file.extension}
                    file={file}
                    thumbUrl={file.thumb}
                    borderRadius={true}
                    removeLoader={() => true}
                    loadThumb={() => true}
                />
            </div>
            <div className={classNames({ [styles.wrapperText]: true })}>
                <div>{errorInfo.text}</div>
                {errorInfo.link && (
                    <div className={styles.infoLink}>
                        <a href={errorInfo.link.url} rel="noopener noreferrer" target="_blank">
                            {errorInfo.link.text}
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
});

InfoErrorComponent.displayName = 'InfoErrorComponent';
